import EnumSortItem from "../../../../utils/enum/EnumSortItem";

const optionsSortBy = [
  { id: EnumSortItem.TIME, label: "Most Recent" },
  { id: EnumSortItem.VOTE, label: "# of Thumbs Up" },
  { id: EnumSortItem.NUM_OF_ANSWERS, label: "# of Responses" },
  { id: EnumSortItem.FLAG, label: "Flagged Posts" },
];

export { optionsSortBy };
